import { render, staticRenderFns } from "./AddFileForRepair.vue?vue&type=template&id=00f090ba&scoped=true&"
import script from "./AddFileForRepair.vue?vue&type=script&lang=js&"
export * from "./AddFileForRepair.vue?vue&type=script&lang=js&"
import style0 from "./AddFileForRepair.vue?vue&type=style&index=0&id=00f090ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f090ba",
  null
  
)

export default component.exports